import { ActionType, ResourceType } from "@/constants";
import { SocketEvent } from "@/interface";

export function updateMessageEvent(resource_id: number, data: any): SocketEvent{
    return {
      action_id: ActionType.Updated,
      resource_type: ResourceType.Message,
      resource_id,
      data,
    }
  }
  